import R from 'ramda'

import getPositioningBoundary from './getPositioningBoundary'

import updateSuggestions from './updateSuggestions'

import {assocPathArray} from '../utils/objUtils'
import applyQueryToUrl from '../utils/applyQueryToUrl'
import getCurrentQuery from '../utils/getCurrentQuery'

const makePositioningValid = (state, query) => {
  const isInParents = (options, parents) => (id) => {
    const option = R.find(R.propEq('id', id), options)
    return R.contains(option.parent, parents)
  }
  const curratedRegionsSelection = R.filter(isInParents(state.options.regions, query.provinces), query.regions)
  const curratedTownsSelection = R.filter(isInParents(state.options.towns, curratedRegionsSelection), query.towns)
  
  return R.evolve({
    regions: R.always(curratedRegionsSelection),
    towns:   R.always(curratedTownsSelection),
  }, query)
}

export default (fieldsName, value) => (dispatch, getState) => {
  const state = getState()
  const query = getCurrentQuery()


  const unValidatedNewQuery = assocPathArray(fieldsName, value, query) 
  const newQuery = makePositioningValid(state, unValidatedNewQuery) 
  applyQueryToUrl(newQuery)

  dispatch(updateSuggestions())

  const positioningProps = ['provinces', 'regions', 'towns']
  const query2Positions = R.pick(positioningProps)
   
  if(R.path(["show", "boundaries"], state) && !R.equals(query2Positions(query), query2Positions(newQuery))){
    dispatch(getPositioningBoundary(newQuery))
  }

}




/** WEBPACK FOOTER **
 ** ./app/actions/searchFormChange.js
 **/